import { MATTER_MODE_ENABLED } from '../config';

export const isMatterTranslationsEnabled = MATTER_MODE_ENABLED;
